<template>
<div class="sessionList mt10">
    <h3 class="columnTit"><span>{{colName}}</span>
        <a :href="'javascript:;'" v-if="$route.query.from">查看更多</a>
        <a :href="link" target="_blank" v-else>查看更多</a>
    </h3>
    <div class="fix">
        <template v-for="(item,i) in organList">
            <dl :key="i" v-if="i<3">
                <dt>
                    <a href="javascript:;" v-if="$route.query.from == 1">
                        <div class="imgBox">
                            <el-image style="width: 100%; height: 100%;object-fit: cover" :src="item.Cover" fit="contain">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                        </div>
                    </a>
                    <router-link :to="{
                    path:'/paimai-'+item.ArtCode+'?from=2',
                }" v-else-if="$route.query.from == 2">
                        <div class="imgBox">
                            <el-image style="width: 100%; height: 100%;object-fit: cover" :src="item.Cover" fit="contain">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                        </div>
                    </router-link>
                    <router-link v-else target="_blank" :to="{
                    path:'/paimai-'+item.ArtCode,
                }">
                        <div class="imgBox">
                            <el-image style="width: 100%; height: 100%;object-fit: cover" :src="item.Cover" fit="contain">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                        </div>
                    </router-link>
                </dt>
                <dd>
                    <h3 class="name">
                        <a href="javasript:;" v-if="$route.query.from == 1">{{nameDelBr(item.Title)}}</a>
                        <router-link :to="{
                    path:'/paimai-'+item.ArtCode+'?from=2',
                }" v-else-if="$route.query.from == 2">
                            {{nameDelBr(item.Title)}}
                        </router-link>
                        <router-link v-else target="_blank" :to="{
                    path:'/paimai-'+item.ArtCode,
                }">{{nameDelBr(item.Title)}}</router-link>
                    </h3>
                    <p><span>LOT号：</span><strong>{{item.TlNumber}}</strong></p>
                    <p>
                        <template v-if="status == 5">
                            <span>成交价：</span>
                            <strong class="price" v-if="isLogin">
                                <template v-if="isMem == 1">
                                    {{item.CurrencyType}} {{formatMoney(item.CurrencyPrice)}}
                                </template>
                                <template v-else>
                                    {{item.CurrencyType}} {{formatNoMemberPrice(item.CurrencyPrice)}}
                                </template>

                            </strong>
                            <strong class="price gotoLogin" v-else @click="gotoLogin">{{item.CurrencyType}} {{formatNoMemberPrice(item.CurrencyPrice)}}</strong>
                        </template>
                        <template v-else>
                            <span>估价：</span>
                            <strong class="price">{{item.CurrencyType}}
                                <template v-if="item.OriginalEvaluation > 0">
                                    {{formatMoney(item.OriginalEvaluation)}}
                                    <template v-if="item.LastEvaluation > 0">-{{formatMoney(item.LastEvaluation)}}</template>
                                </template>
                                <template v-else-if="item.CurrencyPrice > 0">{{formatMoney(item.CurrencyPrice)}}</template>
                            </strong>
                        </template>
                    </p>
                    <p><span>拍卖时间：</span><strong>{{item.Date}}</strong></p>
                    <p><span>专场名称：</span><strong>
                            <a href="javascript:;" v-if="$route.query.from == 1">{{item.special_name}}</a>
                            <router-link v-else-if="$route.query.from == 2" :to="{path:'/special_detail/'+item.special_code+'?from=2'}">{{item.special_name}}</router-link>
                            <router-link v-else target="_blank" :to="{path:'/special_detail/'+item.special_code}">{{item.special_name}}</router-link>
                        </strong></p>
                    <p><span>拍卖机构：</span><strong>
                            <a href="javascript:;" v-if="$route.query.from">{{item.organ_name}}</a>
                            <router-link v-else :to="{path:'/org_detail/'+item.organ_code}">{{item.organ_name}}</router-link>
                        </strong></p>
                </dd>
            </dl>
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: "sessionList",
    props: {
        colName: {
            type: String
        },
        link: {
            type: String
        },
        organList: {
            type: Array
        },
        isLogin: {
            type: Number
        },
        status: {
            type: Number
        },
        isMem: {
            type: Number
        },
        t: {
            type: Number
        }
    },
    methods: {
        nameDelBr(str) {

            return str.replace('<br>', '')
        },
        gotoLogin() {
            if (this.$route.query.from) {
                return false
            }
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        },
        formatMoney(number) {
            let decimals = 0,
                decPoint = '.',
                thousandsSep = ','
            number = (number + '').replace(/[^0-9+-Ee.]/g, '')
            let n = !isFinite(+number) ? 0 : +number
            let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
            let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
            let s = ''
            let toFixedFix = function (n, prec) {
                let k = Math.pow(10, prec)
                return '' + Math.ceil(n * k) / k
            }
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
            let re = /(-?\d+)(\d{3})/
            while (re.test(s[0])) {
                s[0] = s[0].replace(re, '$1' + sep + '$2')
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }
            return s.join(dec)
        },
        formatNoMemberPrice(number) {
            // let num = number.toString().substring(0,1);
            // return num+'***'
            return '****'
        }
    }
}
</script>

<style lang="scss" scoped>
.sessionList {
    .fix dl {
        float: left;
        width: 280px;
        margin-right: 20px;
    }

    dt {
        width: 280px;
        height: 280px;
        border-radius: 4px;
        overflow: hidden;
    }

    .fix dl:last-child {
        margin-right: 0;
    }

    dd {
        .name {
            line-height: 26px;
            font-size: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 10px 0 20px;
        }

        p {
            line-height: 22px;
            margin-bottom: 4px;
            display: flex;
            color: #262626;

            span {
                color: #8C8C8C;
                width: 70px;
            }

            strong {
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .price {
                color: #f5222d;
            }

            .gotoLogin {
                cursor: pointer;
            }
        }

        p:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
